import React from "react";
import useStyles from "./styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";

interface Props {
  children?: React.ReactNode;
  className?: string;
  role?: string;
}

const AppPageTableRow = (props: Props) => {
  const { children, className, ...restProps } = props;
  const classes = useStyles();

  return (
    <Box
      className={clsx(classes.appPageTableRow, className)}
      role="row"
      {...restProps}
    >
      {children}
    </Box>
  );
};

export default AppPageTableRow;
